/**
 * Modified version of the BasicSelectController designed for selecting FontAwesome icons.
 *
 * Expects to receive a list of FontAwesome class names as options, and renders the icon
 * next to the text for each entry.
 */
import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static values = {
    closeAfterSelect: { type: Boolean, default: true },
  };

  connect() {
    var config = {
      plugins: ["remove_button"],
      hidePlaceholder: true,
      closeAfterSelect: this.closeAfterSelectValue,
      maxOptions: null,
      render: {
        option: this.renderIconOptionElement,
        item: this.renderIconOptionElement,
      },
    };

    new TomSelect(this.element, config);
  }

  renderIconOptionElement(data, escape) {
    return `<div>
              <i class="${data.text}"></i>
              <span class="ms-1">${data.text}</span>
            </div>`;
  }
}
